import { useState, useEffect } from 'react';

const useCachedTransactions = (transactionId, apiRequest, setFetchErrorMessage) => {
  const [transactionDetailsInApi, setTransactionDetailsInApi] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // new loading state

  useEffect(() => {
    const loadTransaction = async () => {
      if (!transactionId) return;
      
      setIsLoading(true); // start loading
      try {
        const data = await apiRequest('get', `/transactions/${transactionId}/`);
        setTransactionDetailsInApi(data);
        setFetchErrorMessage(null); // clear any previous errors
      } catch (error) {
        console.error('Error fetching transaction:', error);
        setFetchErrorMessage(error);
        setTransactionDetailsInApi(null); // clear previous data
      } finally {
        setIsLoading(false); // end loading
      }
    };

    loadTransaction();
  }, [transactionId, apiRequest, setFetchErrorMessage]);

  return { transactionDetailsInApi, isLoading };
};

export default useCachedTransactions;
